/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain sequence or FASTA. Lines starting with > are ignored and whitespace and numbers are removed, so pasting directly from a FASTA file works.`)
};

const es_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secuencia simple o FASTA. Las líneas que comienzan con > se ignoran y los espacios en blanco y números se eliminan, así que pegar directamente desde un archivo FASTA funciona.`)
};

const de_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reine Sequenz oder FASTA. Zeilen, die mit > beginnen, werden ignoriert, und Leerzeichen sowie Zahlen werden entfernt, sodass das Einfügen direkt aus einer FASTA-Datei funktioniert.`)
};

const nl_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewone sequentie of FASTA. Regels die beginnen met > worden genegeerd en witruimte en cijfers worden verwijderd, zodat rechtstreeks plakken vanuit een FASTA-bestand werkt.`)
};

const fr_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séquence simple ou FASTA. Les lignes commençant par > sont ignorées et les espaces et chiffres sont supprimés, donc coller directement depuis un fichier FASTA fonctionne.`)
};

const it_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenza semplice o FASTA. Le righe che iniziano con > vengono ignorate e gli spazi bianchi e i numeri vengono rimossi, quindi incollare direttamente da un file FASTA funziona.`)
};

const pt_br2_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência simples ou FASTA. Linhas que começam com > são ignoradas e espaços e números são removidos, então colar diretamente de um arquivo FASTA funciona.`)
};

const pt_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência simples ou FASTA. As linhas que começam por > são ignoradas e os espaços em branco e números são removidos, pelo que colar diretamente de um ficheiro FASTA funciona.`)
};

const ja_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常の配列またはFASTA形式です。>で始まる行は無視され、空白と数字は除去されるため、FASTAファイルから直接貼り付けても動作します。`)
};

const zh_gc_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯序列或 FASTA 格式均可。以 > 开头的行会被忽略，空白和数字会被去除，因此可以直接从 FASTA 文件粘贴。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_a4", locale)
	if (locale === "en") return en_gc_faq_a4(inputs)
	if (locale === "es") return es_gc_faq_a4(inputs)
	if (locale === "de") return de_gc_faq_a4(inputs)
	if (locale === "nl") return nl_gc_faq_a4(inputs)
	if (locale === "fr") return fr_gc_faq_a4(inputs)
	if (locale === "it") return it_gc_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_a4(inputs)
	if (locale === "pt") return pt_gc_faq_a4(inputs)
	if (locale === "ja") return ja_gc_faq_a4(inputs)
	return zh_gc_faq_a4(inputs)
};